import {
  email,
  required,
  useGetIdentity,
  useRecordContext,
  useTranslate,
} from "ra-core";
import { BooleanInput } from "@/components/admin/boolean-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";

import type { Sale } from "../types";

export function SalesInputs() {
  const { identity } = useGetIdentity();
  const record = useRecordContext<Sale>();
  const translate = useTranslate();
  const blogRoles = (["none", "editor", "publisher"] as const).map((id) => ({
    id,
    name: translate(`resources.sales.blog_roles.${id}`),
  }));
  return (
    <div className="space-y-4 w-full">
      <TextInput source="first_name" validate={required()} helperText={false} />
      <TextInput source="last_name" validate={required()} helperText={false} />
      <TextInput
        source="email"
        validate={[required(), email()]}
        helperText={false}
      />
      <BooleanInput
        source="administrator"
        readOnly={record?.id === identity?.id}
        helperText={false}
      />
      <BooleanInput
        source="disabled"
        readOnly={record?.id === identity?.id}
        helperText={false}
      />
      {/* BLOG-005: who may draft and publish real-estate blog posts through
          the Echoflicks MCP. Only administrators can change it (users function). */}
      <SelectInput
        source="blog_role"
        choices={blogRoles}
        defaultValue="none"
        readOnly={!identity?.administrator}
        helperText={false}
      />
    </div>
  );
}
